(function () {
	function swiperInit() {
		// subSliderInit(true);
		// sliderInit(true);
		// popupSliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		if (!window?.isSwiperInit) {
			swiperInit();
		}
	});

	if (!window?.isSwiperInit) {
		swiperInit()
	}

	//This file is loaded from both the main-product.liquid and featured-product.liquid files
	// and is called twice. To avoid the variable being initialized and the slider being
	// instantiated multiple times, need to implement a isSwiperInit variable to prevent double initialization
	window.isSwiperInit = true;
})();

(function () {
  function initProductSliders() {
    document.querySelectorAll('.js-media-list.swiper').forEach(function (mainEl) {
      if (mainEl.swiper) return;

      const wrapper = mainEl.closest('.product__media-list-wrapper');
      if (!wrapper) return;

      const subEl = wrapper.querySelector('.js-media-sublist.swiper');

      // Инициализация превью-слайдера
      let subSwiper = null;
      if (subEl && !subEl.swiper) {
        subSwiper = new Swiper(subEl, {
          direction: subEl.dataset.direction === 'horizontal' ? 'horizontal' : 'vertical',
          slidesPerView: 'auto',
          spaceBetween: 8,
          watchSlidesProgress: true,
          freeMode: true,
        });
      } else if (subEl && subEl.swiper) {
        subSwiper = subEl.swiper;
      }

      // Строим карту: mediaId → индекс слайда в главном слайдере
      // Важно: берём .swiper-slide внутри .swiper-wrapper, именно в том порядке как они есть в DOM
      const mainSlides = Array.from(mainEl.querySelectorAll('.swiper-wrapper > .swiper-slide[data-media-id]'));
      const thumbSlides = subEl 
        ? Array.from(subEl.querySelectorAll('.swiper-wrapper > .swiper-slide[data-media-sub-id]')) 
        : [];

      // Карта mediaId → mainIndex
      const idToMainIndex = {};
      mainSlides.forEach(function (slide, index) {
        idToMainIndex[slide.dataset.mediaId] = index;
      });

      // Карта mediaId → thumbIndex  
      const idToThumbIndex = {};
      thumbSlides.forEach(function (slide, index) {
        idToThumbIndex[slide.dataset.mediaSubId] = index;
      });

      // Инициализация главного слайдера
      const paginationEl = wrapper.querySelector('.product__pagination');
      const prevEl = wrapper.querySelector('.swiper-button-prev');
      const nextEl = wrapper.querySelector('.swiper-button-next');

      const mainSwiper = new Swiper(mainEl, {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
      });

      // slideChange через addEventListener — надёжнее чем on: {} в конфиге
      mainSwiper.on('slideChange', function () {
        syncThumb(mainSwiper, subSwiper, mainSlides, thumbSlides, idToThumbIndex);
      });

      // Клик по превью
      if (subEl) {
        subEl.addEventListener('click', function (e) {
          const thumb = e.target.closest('[data-media-sub-id]');
          if (!thumb) return;

          const mediaId = thumb.dataset.mediaSubId;
          const targetIndex = idToMainIndex[mediaId];

          if (targetIndex !== undefined) {
            mainSwiper.slideTo(targetIndex);
          }
        });
      }

      // Подсветить активный превью при старте
      syncThumb(mainSwiper, subSwiper, mainSlides, thumbSlides, idToThumbIndex);
    });
  }

  function syncThumb(mainSwiper, subSwiper, mainSlides, thumbSlides, idToThumbIndex) {
    if (!subSwiper || !mainSlides.length) return;

    const activeSlide = mainSlides[mainSwiper.activeIndex];
    if (!activeSlide) return;

    const activeId = activeSlide.dataset.mediaId;
    const thumbIndex = idToThumbIndex[activeId];

    thumbSlides.forEach(function (thumb) {
      thumb.classList.remove('is-active');
    });

    if (thumbIndex !== undefined) {
      thumbSlides[thumbIndex].classList.add('is-active');
      subSwiper.slideTo(thumbIndex);
    }
  }

  function init() {
    if (typeof Swiper === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    initProductSliders();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', initProductSliders);
})();